import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HomeState {
  navHeaderId: string;
  navHeaderName: string;
  searchTerm: string;
}

const initialState: HomeState = {
  navHeaderId: '',
  navHeaderName: '',
  searchTerm: '',
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setNavHeader(state, action: PayloadAction<{ id: string; name: string }>) {
      return {
        ...state,
        navHeaderId: action.payload.id,
        navHeaderName: action.payload.name,
      };
    },
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload.trim();
    },
  },
});

export const { setSearchTerm, setNavHeader } = homeSlice.actions;

export default homeSlice.reducer;
